import { InjectionToken } from '@angular/core';

export const NOTIFICATION_OVERLAY_DATA = new InjectionToken<any>('NOTIFICATION_OVERLAY_DATA');
